module.exports = __webpack_public_path__ + "img/stoneholder-1.e54912d.png";